var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part-one"},[_c('p',{staticClass:"top"},[_vm._v("时间：10月1日10:00:00-10月3日23:59:59")]),_c('button',{staticClass:"go-app",on:{"click":function($event){$event.stopPropagation();return _vm.ToLeiDianApp($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }